import { userStore } from '@user';
import { useRecoilValue } from 'recoil';

export const useCurrentOwnerType = () => {
  return useRecoilValue(userStore.ownerTypeSelector);
};
